import { autoinject, bindable, computedFrom } from "aurelia-framework";
import { transient } from "aurelia-dependency-injection";
import { type CompRightStoreProductModel } from "../../../models/rightstore/rightstore.models";
import * as moment from "moment";

@autoinject
@transient()
export class CompRightstoreProduct {

    @bindable
    public product: CompRightStoreProductModel;

    @bindable
    public purchasedBy: string;

    @bindable
    public purchasedDate: Date;

    @bindable
    public buttonValue: string = '';

    @computedFrom("product.expiry")
    get expiryTag(): string {

        if (this.product.expiry) {

            //If smaller than today, then its expired
            if (moment(this.product.expiry) <= moment(new Date())) {
                if (this.product.showInPlatform) {
                    return "Expired. Buy again on RightStore";
                } else {
                    return "Expired.";
                }
            }
            //Else if expiry is within 10 days, then show remaining days
            else if (moment(this.product.expiry).diff(moment(), "days", true) <= 10) {
                const remainingDays = Math.round(moment(this.product.expiry).diff(moment(), "days", true));
                return remainingDays == 0 ? 'Expires Today' : `Expires in ${remainingDays} ${(remainingDays == 1 ? " day" : " days")}`;
            }
            else {
                return "Available until " + moment(this.product.expiry).format("DD MMM YYYY");
            }
        }
    }

    @computedFrom("product.expiry")
    get expiringInLessThan10Days(): boolean {
        const expiryDays = moment(this.product.expiry).diff(moment(), "days", true);
        return expiryDays >= 0 && expiryDays <= 10;
    }

    @computedFrom("product.expiry")
    get expired(): boolean {
        return moment(this.product.expiry) <= moment(new Date())
    }
}